/*
  downloadFile.js
*/

/** 
 * Triggers a download for a given file or URL.
 */
export default function downloadFile(file, name) {
  if (file instanceof Blob) {

    const url = URL.createObjectURL(file);
    const el = document.createElement('a');
    el.href = url;
    el.download = name || file.name || '';
    el.click();
    URL.revokeObjectURL(file);

  } else if (typeof file === 'string') {

    const el = document.createElement('a');
    el.href = file;
    el.download = name || '';
    el.click();

  }
}
